export default __webpack_public_path__ + "static/media/refresh-btn.1ab31e39.svg";